
import PdfExportButton from "./PdfExportButton";

interface PdfExportSectionProps {
  onExport: () => void;
  isExporting: boolean;
  exportProgress: number;
  disabled: boolean;
}

const PdfExportSection = ({ 
  onExport, 
  isExporting, 
  exportProgress, 
  disabled 
}: PdfExportSectionProps) => {
  return (
    <div className="mt-4 pt-3 border-t flex items-center justify-between">
      <div className="flex flex-col sm:flex-row sm:items-start gap-3">
        <PdfExportButton 
          onExport={onExport} 
          isExporting={isExporting}
          exportProgress={exportProgress}
          disabled={disabled} 
        />
        <p className="text-sm text-muted-foreground max-w-[700px]">
          💡 If the seller refuses to refund your money, you can download the entire conversation as a PDF and submit it as evidence to your payment provider (PayPal, bank, or credit card company).
        </p>
      </div>
    </div>
  );
};

export default PdfExportSection;
